import {
	ExportReportActif,
	ExportReportResilie,
} from '@/features/profile/api/export.api';
import {
	TExportActif,
	TExportResilie,
} from '@/features/profile/types/profile.types';
import { ToastError, ToastGeneric } from '@/utils/toast';
import { Icon } from '@iconify/react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
	IconButton,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
} from '@mui/material';
import { FC, useState } from 'react';

type DropdownMenuProps = {
	row: any;
	isActifOrNot: boolean;
	isSendBackOrNot: boolean;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const DropdownMenu: FC<DropdownMenuProps> = ({
	row,
	isActifOrNot,
	isSendBackOrNot,
	setIsLoading,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [isLoading, setisLoading] = useState<boolean>(false);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const exportRow = async (
		isActif: boolean,
		rowId: string,
		typeDoc: string
	) => {
		console.log(`isActif ${isActif}, Id: ${rowId}, type: ${typeDoc}`);
		const toSendResilie: TExportResilie = {
			export: 'Resilie',
			secteur: rowId,
			type_export: typeDoc,
		};

		const toSendActif: TExportActif = {
			export: 'Actif',
			periode: rowId,
			type_export: typeDoc,
		};

		const toSendRembourse: TExportActif = {
			export: 'Remboursement',
			periode: rowId,
			type_export: typeDoc,
		};
		// console.log("ruccentActor ", toSend);
		setIsLoading(true);
		try {
			const response: any = await (isActif
				? ExportReportActif(isSendBackOrNot ? toSendRembourse : toSendActif)
				: ExportReportResilie(toSendResilie));
			if (response.error) {
				ToastError.fire({ text: response.message, timer: 9000 });
				return;
			}

			var data = new Blob([response], {
				type: `text/${typeDoc === 'PDF' ? 'pdf' : 'xlsx'}`,
			});

			var csvURL = window.URL.createObjectURL(data);
			const tempLink = document.createElement('a');
			tempLink.href = csvURL;
			tempLink.setAttribute(
				'download',
				`${
					isActif
						? 'Liste des actifs et résiliés de ' + rowId
						: 'Liste des résiliations du secteur ' + rowId
				}.${typeDoc === 'PDF' ? 'pdf' : 'xlsx'}`
			);
			tempLink.click();

			ToastGeneric(
				'Exportation effectuée avec succès',
				'success',
				3000
			).fire();
		} catch (err) {
			ToastError.fire({ text: "Erreur lors de l'export", timer: 9000 });
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{/* <IconButton onClick={handleClick}>
				<MoreHorizIcon />
			</IconButton> */}
			{/* <Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
			> */}
				<div
				style={{cursor: 'pointer'}}
					onClick={() => {
						exportRow(
							isActifOrNot,
							isActifOrNot ? row.date : row.secteur,
							'Excel'
						);
						handleClose();
					}}
				>
					<ListItemIcon>
						<Icon color='var(--ui-primary)' fontSize={20} icon="vscode-icons:file-type-excel" />
					</ListItemIcon>
					{/* <ListItemText>Exporter en XLS</ListItemText> */}
				</div>
				<div
					style={{cursor: 'pointer'}}
					onClick={() => {
						exportRow(
							isActifOrNot,
							isActifOrNot ? row.date : row.secteur,
							'PDF'
						);
						handleClose();
					}}
				>
					<ListItemIcon>
						<Icon fontSize={20} icon="vscode-icons:file-type-pdf2" />
					</ListItemIcon>
					{/* <ListItemText>Exporter en PDF</ListItemText> */}
				</div>
			{/* </Menu> */}
		</>
	);
};

export default DropdownMenu;
